import { useSyncExternalStore } from "react";

/**
 * Whether a media query matches, kept current as the window changes.
 *
 * The layout renders *one* navigation — the sidebar or the phone's tab strip —
 * rather than both with one hidden by CSS. Two copies of every link would give
 * a screen reader two navigations and give the browser walkthroughs' `text=`
 * selectors a hidden twin to try to click.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
